<div class="remote-container">
  <evrideo-outpost-sidebar
    [activeItemId]="activeItemId"
    (itemClick)="onSidebarItemClick($event)"
  ></evrideo-outpost-sidebar>
  <div class="body">
      @if (iframeSrc) {
        <iframe
          [src]="iframeSrc"
          title="Outpost"
          class="body-iframe"
          (load)="onIframeLoad($event)">
        </iframe>
      }
  </div>
</div>
